<template>
  <div>
    <div class="d-flex flex-column">
      <span class="combo-label">Combo</span>
      <span class="combo-name">{{ combo.name }}</span>
    </div>
    <offer-sale-line :line-items="maxItem">
      <user-consumption :maximum-per-client="combo.maximum_per_client" :user-sale-consumption-amount="combo.userSaleConsumptionAmount" />
    </offer-sale-line>

    <div class="d-flex flex-row align-center my-2" style="gap: 8px">
      <span class="trigger-target-label">Produtos gatilho ({{ triggerProductsAmount }})</span>
      <v-divider color="#00366D"></v-divider>
    </div>

    <combo-offer-sale
      v-for="offerSale in combo.trigger_products"
      :key="offerSale.sku || offerSale._id"
      class="my-2"
      style="flex: 1"
      :offerSale="offerSale"
      type="trigger_products"
      :is-activable="isActivable"
    />

    <div class="d-flex flex-row align-center my-4" style="gap: 8px">
      <span class="trigger-target-label">Produtos com desconto ({{ targetProductsAmount }})</span>
      <v-divider color="#00366D"></v-divider>
    </div>

    <combo-offer-sale
      v-for="offerSale in combo.target_products"
      :key="offerSale.sku || offerSale._id"
      class="my-2"
      style="flex: 1"
      :offerSale="offerSale"
      type="target_products"
      :is-activable="isActivable"
    />
  </div>
</template>

<script>
import OfferSaleLine from './OfferSaleLine.vue'
import UserConsumption from './UserConsumption.vue'
import ComboOfferSale from './ComboOfferSale.vue'

export default {
  name: 'ComboOfferSaleBase',
  components: {
    OfferSaleLine,
    UserConsumption,
    ComboOfferSale,
  },
  props: {
    combo: {
      type: Object,
      required: true,
    },
    isActivable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    userSaleConsumptionAmount() {
      let consumption = 0
      this.combo.trigger_products.forEach((trigger_product) => {
        if (this.isGroup(trigger_product, 'trigger_products')) {
          consumption += trigger_product.trigger_products.reduce((acc, offerSale) => acc + offerSale.user_sale_consumption_amount, 0)
        } else {
          consumption += trigger_product.user_sale_consumption_amount
        }
      })
      return consumption
    },
    triggerProductsAmount() {
      return this.productsAmount('trigger_products')
    },
    targetProductsAmount() {
      return this.productsAmount('target_products')
    },
    maxItem() {
      return [
        {
          label: 'Máximo por CPF',
          value: this.combo.maximum_per_client,
          format: 'text',
        },
      ]
    },
  },
  methods: {
    isGroup(product, type) {
      return product[type] && product[type].length > 0
    },
    productsAmount(type) {
      let quantity = 0
      this.combo[type].forEach((product) => {
        if (this.isGroup(product, type)) {
          quantity += product[type].length
        } else {
          quantity += 1
        }
      })
      return quantity
    },
  },
}
</script>

<style lang="scss" scoped>
.combo-label {
  font-size: 14px;
  font-weight: 400;
  color: $cinza-0;
}

.combo-name {
  font-size: 14px;
  font-weight: 700;
  color: $cinza-d10;
}

.trigger-target-label {
  font-size: 14px;
  font-weight: 700;
  line-height: 16.8px;
  color: $marca-0-l10;
}
</style>
